import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { ErrorOption } from 'react-hook-form'
import { AKAIROS_IS_BUSY_PERIOD, akairosApi } from '~/lib/constants'

import useLocale from '~/hooks/useLocale'
import useOnMutationError from '~/hooks/useOnMutationError'

export default function useGetPreviewImage(
  mutationOptions?: UseMutationOptions<any, any, any>,
  setError?: (name?: string, error?: ErrorOption) => void,
) {
  const locale = useLocale()
  const onMutationError = useOnMutationError(setError)
  return useMutation<any, any, any>(
    async (data: any) => {
      const { variantSku, cacheKey } = data
      const previewUrl = `https://${
        AKAIROS_IS_BUSY_PERIOD ? akairosApi.SECONDARY : akairosApi.MAIN
      }/v1/label/preview/${variantSku}/${cacheKey}?lang=${locale}&withoutBackground=true`

      return previewUrl ?? null
    },
    {
      ...mutationOptions,
      onSuccess: async (data, ...rest) => {
        //! standardize error response
        const error = data?.errors?.[0]
        const errorPayload = { payload: [data?.errors?.[0]] }

        if (error) {
          return onMutationError(errorPayload, rest, mutationOptions?.onError)
        }

        mutationOptions?.onSuccess(data, ...rest)
      },
      onError: (err, ...rest) => {
        onMutationError(err, rest, mutationOptions?.onError)
      },
    },
  )
}
